export default {
  COMMENT_FORM: {
    SUBMIT: {
      osx: "command+enter",
      windows: "ctrl+enter",
      linux: "ctrl+enter"
    }
  }
};



// WEBPACK FOOTER //
// ./src/keymap.js